// 收支台账
import request from '@/api/request'
import download from '@/api/download'

// 增改共用
export function submit(data) {
  return request({
      url: '/market-service/epc/balance/contract/submit',
      method: 'post',
      data
  })
}

export function fetchDetail(params) {
  return request({
      url: `/market-service/epc/balance/contract/query`,
      params
  })
}

// 下载模版
export function downloadTemplate() {
  return download({
      url: '/market-service/epc/balance/contract/export/template',
  })
}
// 导出
export function exportFile(params) {
  return download({
      url: `/market-service/epc/balance/contract/export/${params.id}`,
  })
}

